import classNames from 'classnames'
import React, { useEffect, useRef } from 'react'

import styles from '../../organisms/productPageSections/productDetailsAndCare/productDetailsAndCareV2.module.scss'
import { addClassBasedOnScroll } from '../../organisms/productPageSections/productDetailsAndCare/utils'

import ProductDetailsIcon from './product-details-icon'
import { ProductDetailsIconSectionProps } from './types'

const ProductDetailsIconSection = ({ icons, showPdpV2UI, wrapperClassName }: ProductDetailsIconSectionProps) => {
  const iconsContainerRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (!showPdpV2UI) return
    const el = iconsContainerRef.current
    if (!el) return
    const handleScroll = () => {
      addClassBasedOnScroll(el, styles.noFade ?? 'noFade', 0.9)
    }
    el.addEventListener('scroll', handleScroll)
    return () => {
      el.removeEventListener('scroll', handleScroll)
    }
  }, [])
  if (icons.length === 0) return null
  return (
    <div
      className={classNames(showPdpV2UI && styles.productDetailsAndCareV2__iconsContainer, wrapperClassName)}
      ref={iconsContainerRef}
    >
      {icons.map(icon => (
        <ProductDetailsIcon
          key={icon.displayTitle}
          displayTitle={icon.displayTitle}
          image={icon.image}
          showPdpV2UI={showPdpV2UI}
        />
      ))}
    </div>
  )
}

export default ProductDetailsIconSection
